var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.imgUrl)?_c('img',{attrs:{"src":_vm.imgUrl,"alt":""}}):_c('v-icon',[_vm._v(" mdi-image-off-outline ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }